import React, { useEffect, useState } from 'react';
interface CountdownTimerProps {
  className?: string;
}
export function CountdownTimer({
  className = ''
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 46,
    seconds: 28
  });
  useEffect(() => {
    const savedEndTime = localStorage.getItem('kitProfeEndTime');
    let endTime: number;
    if (savedEndTime) {
      endTime = parseInt(savedEndTime, 10);
      if (Date.now() > endTime) {
        endTime = Date.now() + 23 * 60 * 60 * 1000 + 46 * 60 * 1000 + 28 * 1000;
        localStorage.setItem('kitProfeEndTime', endTime.toString());
      }
    } else {
      endTime = Date.now() + 23 * 60 * 60 * 1000 + 46 * 60 * 1000 + 28 * 1000;
      localStorage.setItem('kitProfeEndTime', endTime.toString());
    }
    const interval = setInterval(() => {
      const difference = endTime - Date.now();
      if (difference <= 0) {
        const newEnd = Date.now() + 23 * 60 * 60 * 1000 + 46 * 60 * 1000 + 28 * 1000;
        localStorage.setItem('kitProfeEndTime', newEnd.toString());
        return;
      }
      setTimeLeft({
        hours: Math.floor(difference / (1000 * 60 * 60) % 24),
        minutes: Math.floor(difference / 1000 / 60 % 60),
        seconds: Math.floor(difference / 1000 % 60)
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const fmt = (n: number) => n.toString().padStart(2, '0');
  return <div className={`flex items-center justify-center space-x-2 font-montserrat font-bold text-xl md:text-3xl text-brand-accent ${className}`} data-id="element-46">
      <div className="bg-brand-dark px-2 py-1 md:px-3 md:py-2 rounded-md border-2 border-brand-accent/50 shadow-sm" data-id="element-47">
        {fmt(timeLeft.hours)}{' '}
        <span className="text-xs md:text-sm text-gray-500" data-id="element-48">hs</span>
      </div>
      <span className="text-brand-accent animate-pulse" data-id="element-49">:</span>
      <div className="bg-brand-dark px-2 py-1 md:px-3 md:py-2 rounded-md border-2 border-brand-accent/50 shadow-sm" data-id="element-50">
        {fmt(timeLeft.minutes)}{' '}
        <span className="text-xs md:text-sm text-gray-500" data-id="element-51">min</span>
      </div>
      <span className="text-brand-accent animate-pulse" data-id="element-52">:</span>
      <div className="bg-brand-dark px-2 py-1 md:px-3 md:py-2 rounded-md border-2 border-brand-accent/50 shadow-sm" data-id="element-53">
        {fmt(timeLeft.seconds)}{' '}
        <span className="text-xs md:text-sm text-gray-500" data-id="element-54">seg</span>
      </div>
    </div>;
}